import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import type { Entity } from '../../types'

const DOC = gql`
  query AdjustmentLabels(
    $tenantId: ID!
    $appId: ID!
    $scenarioId: ID!
    $zoneId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              rate {
                adjustmentLabels
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.AdjustmentLabelsQuery,
    Entity[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'rate',
              graphql.transformers.OUT.select(
                'adjustmentLabels',
                graphql.transformers.OUT.list(
                  graphql.transformers.OUT.object({
                    // NOTE: name and id are same
                    id: {
                      usingFullInput: graphql.transformers.OUT.custom(
                        label => label,
                      ),
                    },
                    name: {
                      usingFullInput: graphql.transformers.OUT.custom(
                        label => label,
                      ),
                    },
                  }),
                  { onNullish: 'remove' },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.AdjustmentLabelsQuery,
  Entity[],
  graphql.schema.AdjustmentLabelsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
